import lodash from "lodash";
import styles from "./plugin-scss.js";
const getContainerData = (node) => {
  const data = `${lodash.camelCase(node.type)}Data`;
  return node?.[data]?.containerData;
};
const getAlignmentClassName = (containerData) => {
  const alignment = containerData?.alignment;
  if (!alignment) {
    return "";
  }
  const key = `align${lodash.upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const size = containerData?.width?.size;
  if (!size || size === "FULL_WIDTH") {
    return "";
  }
  const key = `size${lodash.upperFirst(size.toLowerCase())}`;
  return styles[key];
};
const getTextWrapClassName = (containerData) => {
  if (containerData?.textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node));
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};
export {
  alignmentClassName,
  getAlignmentClassName,
  getSizeClassName,
  getTextWrapClassName,
  sizeClassName,
  textWrapClassName
};
//# sourceMappingURL=getClassNames.js.map
